export default __webpack_public_path__ + "static/AseoInd_2-2dd0ce36dd975002f6bd2c77b91f3cf8.png";